export function fillGeneratedUuids<T>(input: T): T {
  const gen = () =>
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
          const r = (Math.random() * 16) | 0;
          const v = c === 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        });

  const walk = (value: any): any => {
    if (Array.isArray(value)) {
      return value.map(walk);
    }
    if (value && typeof value === 'object' && value !== null) {
      // If the object has a 'type' property, add a 'uuid' if not present
      const out: any = {};
      const hasType = Object.prototype.hasOwnProperty.call(value, 'type');
      for (const [k, v] of Object.entries(value)) {
        out[k] = walk(v);
      }
      if (hasType && !Object.prototype.hasOwnProperty.call(out, 'uuid')) {
        out.uuid = gen();
      }
      return out;
    }
    return value;
  };

  return walk(input);
}

if (typeof window !== 'undefined') {
  (window as any).fillGeneratedUuids = fillGeneratedUuids;
}
